import { createPopper } from "@popperjs/core";
import { isNil, useMergedRefs, useRefState } from "../../shared";
import { useCallback } from "react";
export function useOverlayPosition({
  position = "bottom",
  offset,
  allowFlip = false,
  allowPreventOverflow = false,
  boundaryElement = document.body,
  hasArrow = false
} = {}) {
  const [triggerRef, setTriggerElement] = useRefState();
  const [overlayRef, setOverlayElement] = useRefState();
  const [arrowRef, setArrowElement] = useRefState();
  const [popperInstanceRef, setPopperInstance] = useRefState();
  const createModifiers = useCallback(() => {
    const modifiers = [];

    if (!isNil(offset)) {
      modifiers.push({
        name: "offset",
        options: {
          offset
        }
      });
    }

    modifiers.push({
      enabled: allowFlip,
      name: "flip",
      options: {
        boundary: boundaryElement
      }
    });
    modifiers.push({
      enabled: allowPreventOverflow,
      name: "preventOverflow",
      options: {
        boundary: boundaryElement
      }
    });

    if (hasArrow) {
      modifiers.push({
        name: "arrow",
        options: {
          element: arrowRef.current
        }
      });
    }

    return modifiers;
  }, [offset, allowFlip, allowPreventOverflow, boundaryElement, hasArrow, arrowRef]);
  const createPopperInstance = useCallback(() => {
    if (!isNil(triggerRef.current) && !isNil(overlayRef.current)) {
      if (!hasArrow || hasArrow && !isNil(arrowRef.current)) {
        var _popperInstanceRef$cu;

        (_popperInstanceRef$cu = popperInstanceRef.current) === null || _popperInstanceRef$cu === void 0 ? void 0 : _popperInstanceRef$cu.destroy();
        const instance = createPopper(triggerRef.current, overlayRef.current, {
          modifiers: createModifiers(),
          placement: position,
          strategy: "absolute"
        });
        setPopperInstance(instance);
      }
    }
  }, [position, hasArrow, triggerRef, overlayRef, arrowRef, popperInstanceRef, setPopperInstance, createModifiers]);
  return {
    arrowRef: useMergedRefs(useCallback(element => {
      setArrowElement(element);
      createPopperInstance();
    }, [setArrowElement, createPopperInstance])),
    overlayRef: useMergedRefs(useCallback(element => {
      setOverlayElement(element);
      createPopperInstance();
    }, [setOverlayElement, createPopperInstance])),
    triggerRef: useMergedRefs(useCallback(element => {
      setTriggerElement(element);
      createPopperInstance();
    }, [setTriggerElement, createPopperInstance]))
  };
}